import React from "react";

const CustomersIcon = props => {
  const color = props.color;
  return (
    <svg
      width={24}
      height={20}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>group-of-people-in-a-formation</title>
      <defs>
        <path fill={color} id="a" d="M0 0h24v20H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill={color}
          d="M21.767 6.582c-.753 0-1.36.613-1.36 1.372 0 .761.607 1.375 1.36 1.375.751 0 1.358-.614 1.358-1.375 0-.759-.607-1.372-1.358-1.372zm-19.534 0c-.751 0-1.358.613-1.358 1.372 0 .761.607 1.375 1.358 1.375.751 0 1.358-.614 1.358-1.375 0-.759-.607-1.372-1.358-1.372zm15.494-2.498c-1.12 0-2.024.92-2.024 2.045 0 1.124.904 2.044 2.024 2.044 1.113 0 2.024-.92 2.024-2.044 0-1.125-.91-2.045-2.024-2.045zM24 16.514h-2.305v-4.287a3.99 3.99 0 0 0-.557-2.016 2.27 2.27 0 0 1 .63-.1c1.227 0 2.232 1.015 2.232 2.256v4.148zM6.273 4.085c-1.113 0-2.024.92-2.024 2.045 0 1.124.91 2.044 2.024 2.044 1.112 0 2.022-.92 2.022-2.044 0-1.125-.91-2.045-2.022-2.045zm-4.04 6.026c.224 0 .427.043.629.101a3.971 3.971 0 0 0-.557 2.016v4.288H0v-4.148c0-1.241 1.005-2.257 2.233-2.257zM11.995 0C10.35 0 9.011 1.36 9.011 3.025c0 1.665 1.338 3.024 2.984 3.024 1.649 0 2.994-1.36 2.994-3.024C14.989 1.36 13.644 0 11.995 0zm8.962 18.108H17.43v-6.522c0-.892-.239-1.732-.615-2.478.29-.086.592-.146.91-.146 1.779 0 3.23 1.462 3.23 3.265v5.88zM6.569 11.586v6.522H3.043v-5.881c0-1.803 1.452-3.265 3.238-3.265.316 0 .614.06.903.146a5.509 5.509 0 0 0-.615 2.478zM7.313 20h9.374v-8.414c0-2.609-2.103-4.735-4.692-4.735-2.586 0-4.682 2.126-4.682 4.735V20z"
          mask="url(#b)"
        />
      </g>
    </svg>
  );
};
export default CustomersIcon;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/CustomersIcon.js